import { searchCommonConfig } from './common'

/**
 * NovelMello 品牌搜索页面配置
 *
 * 文案完全复用 searchCommonConfig（i18n getter），仅覆盖颜色 / 尺寸 token。
 * 说明：这里的值来自 00-overview 的设计 tokens，页面级私有（pink-soft / purple-soft /
 * 高亮紫）未进入 UnoCSS 的 n-* 变量体系，因此放在页面配置层而非品牌配置层。
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    // ---- 页面 ----
    pageBg: '#FBF6FB', // bg-global
    // ---- 搜索输入框 ----
    inputBg: '#FFFFFF',
    inputBorder: '#F2EAF4', // 未聚焦：分割线色，保持 1.5px 占位避免聚焦时抖动
    inputBorderFocus: '#F0509B', // 聚焦：主粉
    inputRadius: '20px',
    inputHeight: '40px',
    // ---- 文本 ----
    ink1: '#2B1B34',
    ink2: '#71607E',
    ink3: '#AB9BB8',
    // ---- 关键词高亮 ----
    highlight: '#7C4DE8', // purple
    // ---- chips（粉紫交替）----
    chipPinkBg: '#FDEFF6',
    chipPinkText: '#F0509B',
    chipPurpleBg: '#F3EDFE',
    chipPurpleText: '#7C4DE8',
    // ---- 封面 ----
    coverWidth: '64px',
    coverRadius: '10px',
    coverHeightRate: 137.5, // 88 / 64
    // ---- 兑换码卡片的 Start Reading 按钮 ----
    startReadingBg: 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
  },
  /** chips 最多展示几个 */
  chipLimit: 3,
}
